<div class="menu" #options="cdkMenu" cdkMenu>
  <button class="menu-item" mat-menu-item (click)="selectNode('SHOW_NODES_FROM_HERE')">{{CONTEXT_OPTIONS.show_hierarchy}}</button>
  <button class="menu-item" mat-menu-item (click)="selectNode('SHOW_ONLY_CHILDS_CHAIN')">{{CONTEXT_OPTIONS.show_hierarchy_no_father}}</button>
  <button class="menu-item" mat-menu-item (click)="selectNode('SHOW_ONLY_CHILDS')">{{CONTEXT_OPTIONS.only_children_no_chain}}</button>
  <button class="menu-item" mat-menu-item (click)="selectNode('SHOW_NODE')">{{CONTEXT_OPTIONS.show_node}}</button>
  @if (checkSchema()) {
    <button class="menu-item" mat-menu-item (click)="selectNode('EXPORT_TO_JSON')">{{CONTEXT_OPTIONS.export_taxonomy}}</button>
    <button class="menu-item" mat-menu-item (click)="selectNode('EXPORT_HYPERFLOWS_TO_JSON')">{{CONTEXT_OPTIONS.export_hyperflows}}</button>
  }
  @if (checkSubclass()) {
    <button class="menu-item" mat-menu-item (click)="onSelectFile()">{{CONTEXT_OPTIONS.import_json}}</button>
  }
  <input
    #fileInput
    type="file"
    style="display: none"
    (change)="onFileSelected($event, 'IMPORT_JSON')"
  />
</div>